import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { getNextNDays } from '../../services/monthlyPlan.service';

const WeeklyScheduleContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 130px 10px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  height: 230px;
`;

const ScheduleTitle = styled.h3`
  margin: 0 0 20px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
`;

const DaysContainer = styled.div`
  display: flex;
  gap: 10px;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  
  /* Hide scrollbar for webkit browsers */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  
  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;

const DayItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
`;

const DayLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
  text-align: center;
`;

const DayName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
`;

const DayDate = styled.div`
  font-size: 13px;
  color: #666;
`;

const DayBlock = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props => props.isAbsence ? '#fab10b' : (props.hasShift ? '#185da9' : '#e6e6e6')};

`;

const WeeklySchedule = () => {
  const [scheduleData, setScheduleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchScheduleData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await getNextNDays();
        
        if (response && response.data) {
          const days = ['NED', 'PON', 'UTO', 'SRI', 'ČET', 'PET', 'SUB'];
          const schedule = response.data.map((item, index) => {
            const date = new Date(item.date);
            const dayOfWeek = days[date.getDay()];
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            
            return {
              id: index,
              dayName: dayOfWeek,
              dayDate: `${day}.${month}.`,
              hasShift: item.isShift,
              isAbsence: item.isAbsence,
              shiftName: item.shiftName || item.absenceName,
              shiftId: item.shiftId,
              date: date,
              originalData: item
            };
          });
          
          setScheduleData(schedule);
        } else {
          console.log('No data received from API');
          setError('No schedule data available');
        }
      } catch (err) {
        console.error('Error fetching schedule data:', err);
        setError('Failed to load schedule data');
        setScheduleData([]); // Set empty array instead of mock data
      } finally {
        setLoading(false);
      }
    };
    
    fetchScheduleData();
  }, []);


  if (loading) {
    return (
      <WeeklyScheduleContainer>
        <ScheduleTitle>Sedmični raspored narednih 7 dana</ScheduleTitle>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
        </div>
      </WeeklyScheduleContainer>
    );
  }

  if (error) {
    return (
      <WeeklyScheduleContainer>
        <ScheduleTitle>Sedmični raspored narednih 7 dana</ScheduleTitle>
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          {error}
        </div>
      </WeeklyScheduleContainer>
    );
  }

  return (
    <WeeklyScheduleContainer>
      <ScheduleTitle>Sedmični raspored narednih 7 dana</ScheduleTitle>
      <DaysContainer>
        {scheduleData.map((day) => (
          <DayItem key={day.id}>
            <DayLabel>
              <DayName>{day.dayName}</DayName>
              <DayDate>{day.dayDate}</DayDate>
            </DayLabel>
            <DayBlock 
              hasShift={day.hasShift}
              isAbsence={day.isAbsence}
            >
              {day.shiftName}
            </DayBlock>
          </DayItem>
        ))}
      </DaysContainer>
    </WeeklyScheduleContainer>
  );
};

export default WeeklySchedule;
